import React, { Component } from "react";
import moment from "moment";
import { getUserLocation } from "../utils/location";
class LocationPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: "",
      cities: ["Mumbai", "Pune", "Bangalore", "Hyderabad", "Chennai"],
      locationData: {},
      formattedLocation: "",
      longitude: "",
      lattitude: "",
      postcode: "",
      state: "",
      state_district: "",
    };
  }
  componentDidMount() {}
  userLocation = () => {
    getUserLocation((response) => {
      const {
        lattitude,
        longitude,
        formatted,
        obj: { postcode, state, state_district },
      } = response;
      console.log(JSON.stringify({ formatted }));
      this.setState({
        formattedLocation: formatted,
        longitude,
        lattitude,
        postcode,
        state,
        state_district,
      });
    });
  };
  render() {
    const { selectedLocation, formattedLocation, cities } = this.state;
    return (
      <div style={styles.container}>
        <div style={styles.popupContainer}>
          <div style={styles.popupHeader}>
            <div style={styles.popupHeaderText}>Select your location</div>
          </div>
          <div style={styles.popupBody}>
            <div style={styles.popupBodyText}>We are currently serving in</div>
            <div style={styles.popupBodyLocation}>
              {cities.map((city, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      ...styles.popupBodyLocationItem,
                      borderWidth: selectedLocation == city ? "2px" : "0px",
                    }}
                    onClick={() => {
                      this.setState({
                        selectedLocation: city,
                      });
                    }}
                  >
                    <div style={styles.popupBodyLocationItemText}>{city}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={styles.popupFooter}>
            <div>
              <textarea
                value={formattedLocation}
                onChange={(text) => {
                  alert(JSON.stringify(text));
                  this.setState({ formattedLocation: text });
                }}
              />
            </div>
            <button
              onClick={() => {
                this.userLocation();
              }}
            >
              Detect live location automatically
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default LocationPopup;

const styles = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  popupContainer: {
    width: "400px",
    height: "300px",
    backgroundColor: "#fff",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
  },
  popupHeader: {
    height: "50px",
    backgroundColor: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #e0e0e0",
  },
  popupHeaderText: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  popupBody: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  popupBodyText: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  popupBodyLocation: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  popupBodyLocationItem: {
    width: "100px",
    height: "100px",
    backgroundColor: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px",
    borderRadius: "5px",
    cursor: "pointer",
    borderStyle: "solid",
    borderColor: "#e0e0e0",
  },
  popupBodyLocationItemText: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  popupFooter: {
    height: "50px",
    backgroundColor: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #e0e0e0",
    cursor: "pointer",
  },
};
